module.exports = __webpack_public_path__ + "img/dead-diagram.681d707f.png";